'use strict';

require('./curry.js');
var always = require('./always.js');
require('./_branch.js');
var branch = require('./branch.js');
var id = require('./id.js');
var __chunk_1 = require('./chunk-ba04ad2f.js');
require('./chunk-d7703e54.js');
require('./variadic.js');
require('./compose.js');
require('./_append.js');
require('./append.js');
require('./flip.js');
require('./chunk-56a5551b.js');
require('./chunk-e6d921c6.js');
require('./chunk-ac19a55d.js');
require('./concat.js');
var _concatMap = require('./_concatMap.js');

function filter(p, as) {
  var f = branch(p, id, always(''));
  return __chunk_1.isString(as) ? _concatMap(f, as) : as.filter(p);
}

module.exports = filter;
